var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDpdx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.08,
    height: 37.992,
    viewBox: "0 -1391 8236.8 2099",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dpdx_svg__a",
    d: "M202 508q-23 0-33 12t-11 27q0 10 6 30t21 47 45 51 71 35l32 5h12q33 0 39-1 63-11 105-53t60-93 17-111q0-95-47-217T402 53q-81-75-179-75-100 0-150 78-31 46-31 92v11q0 117 87 211t193 95q61 0 92-31t41-67l3 11q20 83 20 137 0 88-41 124t-93 37q-78 0-121-64 41-6 41-40 0-25-18-44t-44-20zm228-202q0 66-29 94t-68 28q-63 0-111-46-25-28-39-59t-33-102q-18-72-18-105 0-95 100-95 12 0 18 1 77 13 124 90 15 25 35 84t21 110z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_svg__b",
    d: "M23 287q1 3 2 8t5 22 10 31 15 33 20 30 26 22 33 9q75 0 96-64l10 9q62 55 118 55 65 0 102-47t37-114q0-108-76-199T249-10q-22 0-39 6-11 5-23 15t-19 17l-7 8q-1-1-22-87t-21-87q0-6 8-7t37-3h25q6-7 6-9t-3-18q-3-12-6-15t-13-4h-11q-9 0-34 1t-62 1q-70 0-89-2h-8q-7 7-7 11 2 27 13 35h20q34 1 39 12 3 6 61 239t61 247q1 5 1 14 0 41-25 41-22 0-37-28t-23-61-12-36q-2-2-16-2H29q-6 6-6 9zm155-185q22-76 74-76 30 0 58 23t46 58q18 34 36 108t19 110v6q0 74-61 74-11 0-22-3t-22-9-20-13-17-15-15-15-11-14-8-10l-3-4q0-1-3-14t-11-44-14-52q-26-106-26-110z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_svg__c",
    d: "M52 289q7 42 54 97t116 56q35 0 64-18t43-45q42 63 101 63 37 0 64-22t28-59q0-29-14-47t-27-22-23-4q-19 0-31 11t-12 29q0 46 50 63-11 13-40 13-13 0-19-2-38-16-56-66-60-221-60-258 0-28 16-40t35-12q37 0 73 33t49 81q3 10 6 11t16 2h4q15 0 15-8 0-1-2-11-16-57-62-101T333-11q-70 0-106 63-41-62-94-62h-6q-49 0-70 26T35 71q0 32 19 52t45 20q43 0 43-42 0-20-12-35t-23-20-13-5l-3-1q0-1 6-4t16-7 19-3q36 0 62 45 9 16 23 68t28 108 16 66q5 27 5 39 0 28-15 40t-34 12q-40 0-75-32t-49-82q-2-9-5-10t-16-2H58q-6 6-6 11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_svg__d",
    d: "M56 347q0 13 14 20h637q15-8 15-20 0-11-14-19l-318-1H72q-16 5-16 20zm0-194q0 15 16 20h636q14-10 14-20 0-13-15-20H70q-14 7-14 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_svg__e",
    d: "M84 237v13l14 20h581q15-8 15-20t-15-20H98q-14 7-14 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_svg__f",
    d: "M58-216q-33 0-35 30 0 10 50 212t54 208q16 55 55 107 70 86 159 100h8q6 0 10 1 73 0 112-48t39-118q0-57-24-111t-61-91-80-61-79-23h-18q-51 0-83 45l-5 6-27-112q-25-97-29-110t-12-21q-16-14-34-14zm366 538q0 37-17 60t-50 23q-35 0-70-29t-56-76q-14-31-38-130l-17-68q17-76 84-76 38 0 74 36 33 30 55 96t29 108 6 56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_svg__g",
    d: "M96 585q56 81 153 81 48 0 96-26t78-92q37-83 37-228 0-155-43-237-20-42-55-67t-61-31-51-7q-26 0-52 6t-61 32-55 67q-43 82-43 237 0 174 57 265zm225 12q-30 32-71 32-42 0-72-32-25-26-33-72t-8-192q0-158 8-208t36-79q28-30 69-30 40 0 68 30 29 30 36 84t8 203q0 145-8 191t-33 73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_svg__h",
    d: "M173 380q0 25-19 25-24 0-50-29t-43-89q-1-1-2-3t-1-3-2-2-3-1-4 0-8 0H27q-6 6-6 9 0 7 8 29t24 52 44 51 63 22q42 0 65-24t24-56q0-17-3-26 0-6-15-44t-31-89-18-89q0-27 5-44 13-43 63-43 37 0 69 34t50 79 29 83 11 55q0 23-8 40t-18 26-18 18-8 22q0 22 19 41t41 19q19 0 34-18t16-58q0-27-12-83t-37-125-71-119-106-51q-64 0-102 33-37 32-37 95 0 31 8 64t41 117q22 64 22 82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_svg__i",
    d: "M26 385q-7 7-7 10 0 4 3 16t5 14q2 5 9 5t51 1h53l19 80q3 11 7 29t7 26 6 20 8 17 10 12 14 9 18 2q18-1 25-11t7-19q0-7-9-47t-20-79l-10-37q0-2 50-2h51q7-7 7-11 0-22-13-35H210l-36-145Q135 80 135 68q0-42 27-42 35 0 68 34t53 84q2 6 5 7t15 2h4q15 0 15-8 0-3-3-12-5-16-18-38t-34-47-51-42-61-17q-30 0-57 15T59 56q-2 8-2 27v18l35 140q35 141 36 142 0 2-51 2H26z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "math",
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mfrac"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mrow"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__a",
    "data-mml-node": "mi",
    transform: "matrix(1 0 0 -1 254.5 -676)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__b",
    "data-mml-node": "mi",
    transform: "matrix(1 0 0 -1 785.5 -676)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mrow"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__a",
    "data-mml-node": "mi",
    transform: "matrix(1 0 0 -1 220 686)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__c",
    "data-mml-node": "mi",
    transform: "matrix(1 0 0 -1 751 686)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M120-220h1303v-60H120z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__d",
    "data-mml-node": "mo",
    transform: "matrix(1 0 0 -1 1820.8 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__e",
    "data-mml-node": "mo",
    transform: "matrix(1 0 0 -1 2876.6 0)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "msub"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__f",
    "data-mml-node": "mi",
    transform: "matrix(1 0 0 -1 3654.6 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__g",
    "data-mml-node": "mn",
    transform: "matrix(.707 0 0 -.707 4171.6 150)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mfrac"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mrow"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__a",
    "data-mml-node": "mi",
    transform: "matrix(1 0 0 -1 4795.1 -676)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "msub"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__h",
    "data-mml-node": "mi",
    transform: "matrix(1 0 0 -1 5326.1 -676)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__c",
    "data-mml-node": "mi",
    transform: "matrix(.707 0 0 -.707 5811.1 -526)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mrow"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__a",
    "data-mml-node": "mi",
    transform: "matrix(1 0 0 -1 5084.3 686)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__i",
    "data-mml-node": "mi",
    transform: "matrix(1 0 0 -1 5615.3 686)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M4695.1-220h1670.5v-60H4695.1z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_svg__d",
    "data-mml-node": "mo",
    transform: "matrix(1 0 0 -1 6763.4 0)"
  }))));
}
export default __webpack_public_path__ + "09ec96b4160fa56ebe5f69e0692ddc9c.svg";
export { SvgDpdx as ReactComponent };